/* SCRUBZ bundle controller: one main-product color, independent component sizes. */
(function (window, document) {
  'use strict';

  if (window.__scrubzBundle) return;
  window.__scrubzBundle = true;

  function parseJson(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function handleize(value) {
    return normalize(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  var COLOR_OPTION_NAMES = ['color', 'colors', 'colour', 'colours', 'couleur'];
  var SIZE_OPTION_NAMES = ['size', 'sizes', 'größe', 'taille'];

  function optionNameAt(options, index) {
    var entry = options[index];
    return entry && typeof entry === 'object' ? entry.name : entry;
  }

  function colorOptionIndex(options) {
    if (!Array.isArray(options)) return -1;
    for (var i = 0; i < options.length; i++) {
      if (COLOR_OPTION_NAMES.indexOf(normalize(optionNameAt(options, i))) !== -1) return i;
    }
    return -1;
  }

  function sizeOptionIndex(options, colorIndex) {
    if (!Array.isArray(options)) return -1;
    for (var i = 0; i < options.length; i++) {
      if (i !== colorIndex && SIZE_OPTION_NAMES.indexOf(normalize(optionNameAt(options, i))) !== -1) return i;
    }
    return -1;
  }

  function findItem(items, index) {
    return items.filter(function (item) { return item.index === index; })[0] || null;
  }

  function variantMatches(item, variant, color, selections) {
    if (!variant || !Array.isArray(variant.options)) return false;
    if (item.colorIndex !== -1 && normalize(variant.options[item.colorIndex]) !== normalize(color)) return false;
    return Object.keys(selections || {}).every(function (index) {
      return normalize(variant.options[parseInt(index, 10)]) === normalize(selections[index]);
    });
  }

  function requiredOptionIndexes(item) {
    var indexes = [];
    for (var i = 0; i < item.data.options.length; i++) {
      if (i !== item.colorIndex) indexes.push(i);
    }
    return indexes;
  }

  function hasAvailableVariant(item, color, selections) {
    return item.data.variants.some(function (variant) {
      return variant.available && variantMatches(item, variant, color, selections);
    });
  }

  function hasAvailableColor(item, color) {
    return item.colorIndex === -1 || hasAvailableVariant(item, color, {});
  }

  function sharedAvailableColors(items) {
    if (!items.length || items.some(function (item) { return item.colorIndex === -1; })) return [];
    var first = {};
    items[0].data.variants.forEach(function (variant) {
      if (!variant.available) return;
      var value = variant.options[items[0].colorIndex];
      if (value) first[normalize(value)] = value;
    });
    return Object.keys(first).map(function (key) { return first[key]; }).filter(function (color) {
      return items.every(function (item) { return hasAvailableColor(item, color); });
    });
  }

  function findVariant(item, color, selections) {
    if (!item || !color) return null;
    var required = requiredOptionIndexes(item);
    if (required.some(function (index) { return !selections[index]; })) return null;
    return item.data.variants.filter(function (variant) {
      return variantMatches(item, variant, color, selections);
    })[0] || null;
  }

  function optionValueAvailable(item, color, selections, index, value) {
    var prospective = {};
    Object.keys(selections).forEach(function (key) { prospective[key] = selections[key]; });
    prospective[index] = value;
    return hasAvailableVariant(item, color, prospective);
  }

  function findItemImageForColor(item, color) {
    if (!item || !item.data.variants.length) return null;
    var matching = item.data.variants.filter(function (variant) {
      return item.colorIndex === -1 || normalize(variant.options[item.colorIndex]) === normalize(color);
    });
    var imageVariant = matching.filter(function (variant) { return variant.image; })[0];
    return imageVariant ? imageVariant.image : (item.data.variants[0].image || null);
  }

  function parentMediaIdsForColor(parent, color) {
    if (!parent || !Array.isArray(parent.variants) || parent.colorIndex < 0) return [];
    var ids = {};
    parent.variants.forEach(function (variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      if (normalize(variant.options[parent.colorIndex]) !== normalize(color)) return;
      if (variant.featuredMediaId != null) ids[String(variant.featuredMediaId)] = true;
    });
    return Object.keys(ids);
  }

  function initialize($) {
    var root = document.querySelector('[data-scrubz-bundle]');
    if (!root) return;

    var payload = parseJson((root.querySelector('[data-scrubz-bundle-data]') || {}).textContent, null);
    var rawItems = payload && Array.isArray(payload.items) ? payload.items : (Array.isArray(payload) ? payload : []);
    var parent = parseJson((root.querySelector('[data-scrubz-bundle-parent-media]') || {}).textContent, null);
    if (!rawItems.length) return;

    var state = { currentColor: null, items: [] };
    rawItems.forEach(function (data) {
      var element = root.querySelector('[data-scrubz-bundle-item="' + data.index + '"]');
      if (!element) return;
      var configuredColorIndex = parseInt(element.getAttribute('data-scrubz-bundle-color-index'), 10);
      var colorIndex = configuredColorIndex >= 0 ? configuredColorIndex : colorOptionIndex(data.options);
      state.items.push({
        index: data.index,
        data: data,
        element: element,
        colorIndex: colorIndex,
        sizeIndex: sizeOptionIndex(data.options, colorIndex),
        selectedOptions: {},
        embroidery: null,
        label: data.title
      });
    });
    if (!state.items.length) return;

    var sharedColors = sharedAvailableColors(state.items);

    var errorWrap = root.querySelector('[data-scrubz-bundle-error-wrap]');
    var errorMessage = root.querySelector('[data-scrubz-bundle-message]');
    var addButton = document.querySelector('[data-scrubz-bundle-add]');
    if (addButton && addButton.parentNode) {
      var replacement = addButton.cloneNode(true);
      addButton.parentNode.replaceChild(replacement, addButton);
      addButton = replacement;
    }

    function showError(message) {
      if (errorMessage) errorMessage.textContent = message;
      if (errorWrap) errorWrap.style.display = 'block';
    }

    function hideError() {
      if (errorMessage) errorMessage.textContent = '';
      if (errorWrap) errorWrap.style.display = 'none';
    }

    function applyCardImage(item, imageUrl) {
      if (!imageUrl) return;
      var image = item.element.querySelector('[data-scrubz-bundle-image]');
      if (!image) return;
      image.setAttribute('data-bgset', imageUrl);
      image.style.backgroundImage = 'url("' + imageUrl + '")';
      var imageTag = image.querySelector('img');
      if (imageTag) imageTag.setAttribute('src', imageUrl);
    }

    function refreshMainGallery(gallery) {
      var $gallery = $(gallery);
      var $productImages = $gallery.closest('.product-images');
      var $navigation = $productImages.find('.p-nav.flickity-enabled');
      if ($navigation.length) $navigation.removeClass('p-nav-ready').flickity('destroy');

      if ($gallery.hasClass('isotope_ok')) {
        $gallery.isotope();
      } else if ($gallery.hasClass('flickity-enabled')) {
        $gallery.flickity('deactivate').flickity('activate');
      }

      if (window.geckoShopify && typeof window.geckoShopify.productImagesThumb === 'function' && $gallery.hasClass('p-thumb_ppr')) {
        window.geckoShopify.productImagesThumb('_ppr');
      }
      return $gallery;
    }

    function restoreMainGallery(gallery) {
      if (!gallery) return $();
      var $gallery = $(gallery);
      if ($gallery.find('.js-sl-item.is_varhide').length) {
        $gallery.find('.js-sl-item').removeClass('is_varhide');
        refreshMainGallery(gallery);
      }
      return $gallery;
    }

    function updateMainGallery(color) {
      var parentMediaIds = parentMediaIdsForColor(parent, color);
      var gallery = document.querySelector('[data-featured-product-se][data-id="_ppr"] .product-images .p-thumb_ppr') ||
        document.querySelector('.product-images .p-thumb_ppr, .product-images .p-thumb');
      if (!gallery) return false;

      var cells = Array.prototype.slice.call(gallery.querySelectorAll('.js-sl-item'));
      if (!cells.length) return false;

      var target = cells.filter(function (cell) {
        return parentMediaIds.indexOf(String(cell.getAttribute('data-mdid') || '')) !== -1;
      })[0] || cells[0];

      var $gallery = restoreMainGallery(gallery);
      if (!$gallery.hasClass('flickity-enabled')) return target !== cells[0];

      var mediaId = target.getAttribute('data-mdid');
      if (mediaId) {
        $gallery.flickity('selectCell', '[data-mdid="' + mediaId + '"]', false, true);
        return target !== cells[0];
      }
      $gallery.flickity('select', 0, false, true);
      return false;
    }

    function renderSharedColors() {
      var colorList = root.querySelector('[data-scrubz-bundle-colors]');
      var colorLabel = root.querySelector('[data-scrubz-bundle-color-label]');
      var unavailable = root.querySelector('[data-scrubz-bundle-color-unavailable]');
      if (!colorList) return;
      colorList.innerHTML = '';
      sharedColors.forEach(function (color, index) {
        var colorHandle = handleize(color);
        var swatch = document.createElement('li');
        swatch.className = 'ttip_nt tooltip_top' + (index === 0 ? '_right' : '') + ' nt-swatch swatch_pr_item bg_css_' + colorHandle;
        swatch.setAttribute('data-escape', color);
        swatch.setAttribute('data-color', color);
        swatch.setAttribute('role', 'radio');
        swatch.setAttribute('aria-checked', 'false');
        var tooltip = document.createElement('span');
        tooltip.className = 'tt_txt';
        tooltip.textContent = color;
        var fill = document.createElement('span');
        fill.className = 'swatch__value_pr pr bg_color_' + colorHandle + ' lazyloaded';
        swatch.appendChild(tooltip);
        swatch.appendChild(fill);
        colorList.appendChild(swatch);
      });
      if (colorLabel) colorLabel.textContent = state.currentColor || 'Select a color';
      if (unavailable) {
        unavailable.textContent = sharedColors.length ? '' : 'This set has no color currently available for every item.';
        unavailable.style.display = sharedColors.length ? 'none' : 'block';
      }
    }

    function updateItemOptions(item) {
      requiredOptionIndexes(item).forEach(function (index) {
        if (item.selectedOptions[index] && !optionValueAvailable(item, state.currentColor, item.selectedOptions, index, item.selectedOptions[index])) {
          delete item.selectedOptions[index];
        }
      });

      item.element.querySelectorAll('[data-scrubz-bundle-option-list]').forEach(function (list) {
        var index = parseInt(list.getAttribute('data-scrubz-bundle-option-index'), 10);
        list.querySelectorAll('.nt-swatch').forEach(function (swatch) {
          var value = swatch.getAttribute('data-escape') || swatch.textContent.trim();
          var available = optionValueAvailable(item, state.currentColor, item.selectedOptions, index, value);
          var selected = normalize(item.selectedOptions[index]) === normalize(value);
          swatch.hidden = !available;
          swatch.style.display = available ? '' : 'none';
          swatch.classList.toggle('nt_sold_out', !available);
          swatch.classList.toggle('is-sold-out', !available);
          swatch.classList.toggle('is-selected-nt', selected && available);
          swatch.setAttribute('aria-disabled', available ? 'false' : 'true');
          swatch.setAttribute('aria-checked', selected && available ? 'true' : 'false');
        });
        var label = item.element.querySelector('[data-scrubz-bundle-option-label="' + index + '"]');
        if (label) label.textContent = item.selectedOptions[index] || (index === item.sizeIndex ? 'Select size' : 'Select ' + optionNameAt(item.data.options, index));
      });

      var variant = findVariant(item, state.currentColor, item.selectedOptions);
      var select = item.element.querySelector('[data-scrubz-bundle-select]');
      if (select) {
        select.value = variant && variant.available ? String(variant.id) : '';
        $(select).trigger('change');
      }
      if (variant && variant.available && variant.image) applyCardImage(item, variant.image);
    }

    function validateBundle() {
      if (!state.currentColor) return { valid: false, error: 'Please choose a color.' };
      for (var i = 0; i < state.items.length; i++) {
        var item = state.items[i];
        if (!hasAvailableColor(item, state.currentColor)) {
          return { valid: false, error: item.label + ' is unavailable in ' + state.currentColor + '.' };
        }
        var required = requiredOptionIndexes(item);
        for (var r = 0; r < required.length; r++) {
          if (!item.selectedOptions[required[r]]) {
            return { valid: false, error: 'Please select ' + optionNameAt(item.data.options, required[r]) + ' for ' + item.label + '.' };
          }
        }
        var variant = findVariant(item, state.currentColor, item.selectedOptions);
        if (!variant || !variant.available) return { valid: false, error: 'This selection is unavailable for ' + item.label + '.' };
      }
      return { valid: true };
    }

    function updateButton() {
      if (!addButton) return;
      var status = validateBundle();
      addButton.setAttribute('aria-disabled', status.valid ? 'false' : 'true');
      addButton.classList.toggle('disabled', !status.valid);
    }

    function setColor(color, updateGallery) {
      if (sharedColors.map(normalize).indexOf(normalize(color)) === -1) {
        showError('This color is not available for every item in the set.');
        return;
      }
      state.currentColor = color;
      var colorLabel = root.querySelector('[data-scrubz-bundle-color-label]');
      if (colorLabel) colorLabel.textContent = color;
      root.querySelectorAll('[data-scrubz-bundle-colors] .nt-swatch').forEach(function (swatch) {
        var selected = normalize(swatch.getAttribute('data-color')) === normalize(color);
        swatch.classList.toggle('is-selected-nt', selected);
        swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      state.items.forEach(function (item) {
        applyCardImage(item, findItemImageForColor(item, color));
        updateItemOptions(item);
      });
      if (updateGallery) updateMainGallery(color);
      hideError();
      updateButton();
    }

    function selectOption(item, index, value) {
      if (!optionValueAvailable(item, state.currentColor, item.selectedOptions, index, value)) {
        showError(value + ' is unavailable for ' + item.label + ' in ' + state.currentColor + '.');
        return;
      }
      item.selectedOptions[index] = value;
      hideError();
      updateItemOptions(item);
      updateButton();
    }

    root.addEventListener('click', function (event) {
      var colorSwatch = event.target.closest('[data-scrubz-bundle-colors] .nt-swatch');
      if (colorSwatch && root.contains(colorSwatch)) {
        event.preventDefault();
        event.stopPropagation();
        setColor(colorSwatch.getAttribute('data-color') || colorSwatch.getAttribute('data-escape'), true);
        return;
      }
      var swatch = event.target.closest('[data-scrubz-bundle-option-list] .nt-swatch');
      if (!swatch || !root.contains(swatch)) return;
      event.preventDefault();
      event.stopPropagation();
      var list = swatch.closest('[data-scrubz-bundle-option-list]');
      var itemElement = swatch.closest('[data-scrubz-bundle-item]');
      var item = itemElement && findItem(state.items, parseInt(itemElement.getAttribute('data-scrubz-bundle-item'), 10));
      if (!item) return;
      selectOption(item, parseInt(list.getAttribute('data-scrubz-bundle-option-index'), 10), swatch.getAttribute('data-escape') || swatch.textContent.trim());
    }, true);

    $(root).on('click.scrubzBundleEmbroidery', '[data-scrubz-bundle-embroidery]', function () {
      var item = findItem(state.items, parseInt(this.getAttribute('data-scrubz-bundle-embroidery'), 10));
      if (!item) return;
      $(document).off('click.scrubzBundleSaveEmbroidery').on('click.scrubzBundleSaveEmbroidery', '.save_button_image, .save_both_button_image', function () {
        window.setTimeout(function () {
          var text = $('#special-instructions').val() || $('#both-special-instructions').val() || '';
          if (!text) return;
          item.embroidery = { properties: { 'Special Instructions': text, 'Fonts': window.custom_font || '', 'Colors': window.custom_color || '', 'Position': window.custom_position || '', 'Line 1': window.custom_line1 || '', 'Line 2': window.custom_line2 || '', 'Line 3': window.custom_line3 || '' } };
        }, 350);
      });
    });

    if (addButton) {
      $(addButton).on('click.scrubzBundleAdd', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var status = validateBundle();
        if (!status.valid) {
          showError(status.error);
          if (errorWrap && errorWrap.scrollIntoView) errorWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }
        if (addButton.getAttribute('data-busy') === 'true') return;
        addButton.setAttribute('data-busy', 'true');
        addButton.classList.add('loading');
        var lineItems = state.items.map(function (item) {
          var variant = findVariant(item, state.currentColor, item.selectedOptions);
          var entry = { id: variant.id, quantity: 1 };
          if (item.embroidery && item.embroidery.properties) entry.properties = item.embroidery.properties;
          return entry;
        });
        $.ajax({ type: 'POST', url: '/cart/add.js', data: { items: lineItems }, dataType: 'json' }).done(function () {
          window.location.href = '/cart';
        }).fail(function (xhr) {
          addButton.setAttribute('data-busy', 'false');
          addButton.classList.remove('loading');
          showError(xhr && xhr.responseJSON && xhr.responseJSON.description ? xhr.responseJSON.description : 'Unable to add bundle to cart. Please check availability and try again.');
          updateButton();
        });
      });
    }

    state.currentColor = sharedColors[0] || null;
    renderSharedColors();
    restoreMainGallery(document.querySelector('.product-images .p-thumb_ppr, .product-images .p-thumb'));
    if (state.currentColor) setColor(state.currentColor, false); else updateButton();
  }

  function waitForThemeJQuery(attempt) {
    var themeJQuery = window.jQuery_T4NT || window.jQuery;
    if (themeJQuery) { themeJQuery(function ($) { initialize($); }); return; }
    if (attempt < 60) window.setTimeout(function () { waitForThemeJQuery(attempt + 1); }, 50);
  }

  waitForThemeJQuery(0);

  window.ScrubzBundle = { colorOptionIndex: colorOptionIndex, sizeOptionIndex: sizeOptionIndex, sharedAvailableColors: sharedAvailableColors, optionValueAvailable: optionValueAvailable, findVariant: findVariant, findItemImageForColor: findItemImageForColor, parentMediaIdsForColor: parentMediaIdsForColor, normalize: normalize };
})(window, document);
